// src/layouts/portfolio/components/PortfolioModal.jsx

import React, { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleChevronLeft, faCircleChevronRight } from "@fortawesome/free-solid-svg-icons";
import { GlobalStyles } from "@mui/material";
import { faArrowUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";
import { faUpRightAndDownLeftFromCenter } from "@fortawesome/free-solid-svg-icons";

// FontAwesome com ícone central de vídeo
import { faCirclePlay } from "@fortawesome/free-solid-svg-icons";

import Tooltip from "@mui/material/Tooltip";
import ReactPlayer from "react-player";

// Função para acessar imagens públicas
const publicImg = (file) => `${process.env.PUBLIC_URL}/assets/img/${file}`;

// Estilo para as setas do carrossel
const arrowButtonStyle = {
  position: "absolute",
  top: "50%",
  transform: "translateY(-50%)",
  zIndex: 5,
  width: "38px",
  height: "38px",
  borderRadius: "50%",
  backgroundColor: "rgba(255, 255, 255, 0.15)",
  color: "#FFFFFF",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  boxShadow: "0 0 8px rgba(0,0,0,0.2)",
  transition: "all 0.3s ease-in-out",
};

const NextArrow = ({ onClick }) => (
  <div onClick={onClick} style={{ ...arrowButtonStyle, right: "-20px" }}>
    <FontAwesomeIcon icon={faCircleChevronRight} size="lg" />
  </div>
);

const PrevArrow = ({ onClick }) => (
  <div onClick={onClick} style={{ ...arrowButtonStyle, left: "-20px" }}>
    <FontAwesomeIcon icon={faCircleChevronLeft} size="lg" />
  </div>
);

const PortfolioModal = ({ open, onClose, project }) => {
  if (!project) return null;

  const criativos = Array.isArray(project.assets?.criativo)
    ? project.assets.criativo
    : project.assets?.criativo
    ? [project.assets.criativo]
    : [];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    appendDots: (dots) => (
      <div style={{ marginTop: "-16px", marginBottom: "12px" }}>
        <ul style={{ padding: 0, margin: 0 }}> {dots} </ul>
      </div>
    ),
  };

  const customMaxWidth = project.modalSize === "widescreen" ? "lg" : "md";

  const [modalImagem, setModalImagem] = useState(null);

  const [modalVideo, setModalVideo] = useState(null);


  // Lista de imagens do efeito LikePi
  const imagensEfeitoLikePi = [
    publicImg("likepi/efeito/flap-casa-aberto.webp"),
    publicImg("likepi/efeito/flap-casa-fechado.webp"),
    publicImg("likepi/efeito/flap-escritorio-aberto.webp"),
    publicImg("likepi/efeito/flap-escritorio-fechado.webp"),
  ];

  return (
    <>
      <GlobalStyles
        styles={{
          ".slick-dots li button:before": {
            color: "#FFFFFF",
            fontSize: "12px",
            opacity: 0.4,
          },
          ".slick-dots li.slick-active button:before": {
            color: "#FFFFFF",
            opacity: 1,
          },
        }}
      />

      <Dialog
        open={open}
        onClose={onClose}
        maxWidth={customMaxWidth}
        fullWidth
        PaperProps={{
          sx: {
            backgroundColor: "#1E1F2F",
            borderRadius: "20px",
            padding: 2,
            position: "relative",
          },
        }}
        >
        <DialogTitle>
          <VuiBox display="flex" justifyContent="space-between" alignItems="center">
            <VuiTypography variant="h5" color="white" fontWeight="bold">
              {project.title}
            </VuiTypography>
            <IconButton onClick={onClose} sx={{ color: "#fff" }}>
              <CloseIcon />
            </IconButton>
          </VuiBox>
        </DialogTitle>

        <DialogContent>
          <VuiBox>
            {/* Conteúdo normal do portfólio */}
            {criativos.length > 1 ? (
              <VuiBox mb={3} sx={{ position: "relative" }}>
                <Slider {...settings}>
                  {criativos.map((img, i) => (
                    <div key={i}>
                      <img
                        src={img}
                        alt={`Slide ${i + 1}`}
                        style={{
                          width: "100%",
                          borderRadius: "12px",
                          marginBottom: "16px",
                        }}
                      />
                    </div>
                  ))}
                </Slider>
              </VuiBox>
            ) : criativos.length === 1 ? (
              <VuiBox mb={3}>
                <img
                  src={criativos[0]}
                  alt="Criativo"
                  style={{
                    width: "100%",
                    borderRadius: "12px",
                    marginBottom: "16px",
                  }}
                />
              </VuiBox>
            ) : null}

            {/* 🟢 BLOCO MODULAR: Thumbs de vídeos com ícone de play */}
            {project.assets?.videoThumbs && (
              <VuiBox mb={4}>
                {project.assets?.videoLayout === "single" ? (
                  project.assets.videoThumbs.map((video, idx) => (
                    <VuiBox
                      key={idx}
                      sx={{
                        position: "relative",
                        width: "100%",
                        maxWidth: "420px",
                        margin: "0 auto",
                        borderRadius: "16px",
                        overflow: "hidden",
                        cursor: "pointer",
                      }}
                      onClick={() => setModalVideo(video.src)}
                    >
                      <img
                        src={video.thumb}
                        alt={`Vídeo ${idx + 1}`}
                        style={{ width: "100%", display: "block" }}
                      />

                      <FontAwesomeIcon
                        icon={faCirclePlay}
                        size="2xl"
                        style={{
                          position: "absolute",
                          top: "50%",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                          color: "#fff",
                          opacity: 0.8,
                        }}
                      />
                    </VuiBox>
                  ))
                ) : (
                  <Slider {...settings}>
                    {project.assets.videoThumbs.map((video, idx) => (
                      <VuiBox
                        key={idx}
                        sx={{
                          position: "relative",
                          width: "100%",
                          maxWidth: "960px",
                          margin: "0 auto",
                          borderRadius: "16px",
                          overflow: "hidden",
                          cursor: "pointer",
                        }}
                        onClick={() => setModalVideo(video.src)}
                      >
                        <img
                          src={video.thumb}
                          alt={`Vídeo ${idx + 1}`}
                          style={{ width: "100%", display: "block" }}
                        />

                        <FontAwesomeIcon
                          icon={faCirclePlay}
                          size="2xl"
                          style={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            color: "#fff",
                            opacity: 0.8,
                          }}
                        />
                      </VuiBox>
                    ))}
                  </Slider>
                )}
              </VuiBox>
            )}
            
            <VuiTypography variant="body2" color="text" mb={3}>
              {project.descriptionLong || project.description}
            </VuiTypography>

            {/* Efeito especial para a Landing Page LikePi / Site Perfecto */}
            {project.title.includes("LinkedIn") ? (
              <>
                {/* LikePi: Efeito Especial */}
                <VuiBox
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                    overflow: "hidden",
                    borderRadius: "20px",
                    backgroundColor: "#FFFFFF",
                  }}
                >
                  {/* Linha superior */}
                  <VuiBox
                    sx={{
                      display: "flex",
                      width: "100%",
                      height: "auto",
                      overflow: "hidden",
                    }}
                  >
                    <img
                      src={publicImg("likepi/efeito/abre-lado-esquerdo.webp")}
                      alt="Landing Page Esquerda"
                      style={{
                        width: "38%",
                        objectFit: "cover",
                        borderTopLeftRadius: "20px",
                        borderTopRightRadius: "0",
                        borderBottomLeftRadius: "0",
                        borderBottomRightRadius: "0",
                      }}
                    />

                    <VuiBox
                      sx={{
                        width: "62%",
                        display: "flex",
                        alignItems: "stretch",
                        overflow: "hidden",
                      }}
                    >
                      <SlideShowLikePi images={imagensEfeitoLikePi} />
                    </VuiBox>
                  </VuiBox>

                  {/* Linha inferior */}
                  {project.assets?.landingPage && (
                    <img
                      src={project.assets.landingPage}
                      alt="Landing Page Completa"
                      style={{
                        width: "100%",
                        objectFit: "cover",
                        borderTopLeftRadius: "0",
                        borderTopRightRadius: "0",
                        borderBottomLeftRadius: "20px",
                        borderBottomRightRadius: "0",
                      }}
                    />
                  )}
                </VuiBox>
              </>

            ) : project.assets?.landingPreview ? (
              <>
                {/* 🔻 Estrutura exclusiva para Landing Pages (com apenas 1 botão - Ver maior) */}
                <VuiBox
                  sx={{
                    position: "relative",
                    borderRadius: "20px",
                    overflow: "visible",
                    mt: 4,
                  }}
                >
                  <img
                    src={project.assets.landingPreview}
                    alt="Landing Page Preview"
                    style={{
                      width: "100%",
                      objectFit: "cover",
                      borderRadius: "20px",
                    }}
                  />

                  {project.assets?.landingFull && (
                    <VuiBox
                      sx={{
                        position: "absolute",
                        top: "50%",
                        right: -8,
                        transform: "translateY(-50%)",
                        display: "flex",
                        flexDirection: "column",
                        gap: 1,
                        zIndex: 10,
                      }}
                    >
                      <Tooltip title="Ver maior" placement="left">
                        <VuiBox
                          onClick={() => setModalImagem(project.assets.landingFull)}
                          sx={{
                            width: "44px",
                            height: "44px",
                            borderRadius: "999px",
                            backgroundColor: "rgba(255, 255, 255, 0.6)",
                            backdropFilter: "blur(6px)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                            boxShadow: "0 0 10px rgba(0,0,0,0.2)",
                            transition: "all 0.3s ease",
                            "&:hover": {
                              backgroundColor: "#e2e8f0",
                              transform: "scale(1.05)",
                            },
                          }}
                        >
                          <FontAwesomeIcon icon={faArrowUpRightFromSquare} size="sm" color="#0f172a" />
                        </VuiBox>
                      </Tooltip>
                    </VuiBox>
                  )}
                </VuiBox>
              </>

            ) : project.assets?.sitePreview ? (
              <>
                {/* Novo: estrutura para sitePreview */}
                <VuiBox
                  sx={{
                    position: "relative",
                    borderRadius: "20px",
                    overflow: "visible",
                    mt: 4,
                  }}
                >
                  <img
                    src={project.assets.sitePreview}
                    alt="Site Perfecto Espanhol"
                    style={{
                      width: "100%",
                      objectFit: "cover",
                      borderRadius: "20px",
                    }}
                  />

                  {project.assets?.siteFull && project.assets?.externalUrl && (
                    <VuiBox
                    sx={{
                      position: "absolute",
                      top: "50%", // 🟢 Centraliza verticalmente
                      right: -10,  // 🟢 Encosta na lateral direita
                      transform: "translateY(-50%)", // 🟢 Corrige para centralização real
                      display: "flex",
                      flexDirection: "column",
                      gap: 1,
                      zIndex: 10,
                    }}
                  >
                    {/* Botão 1: Ver maior (abre modal interno) */}
                    <Tooltip title="Ver maior" placement="left">
                      <VuiBox
                        onClick={() => setModalImagem(project.assets.siteFull || "")}
                        sx={{
                          width: "44px",
                          height: "44px",
                          borderRadius: "999px",
                          backgroundColor: "rgba(255, 255, 255, 0.5)", // Aqui adiciona a transparência
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                          boxShadow: "0 0 10px rgba(0,0,0,0.2)",
                          transition: "all 0.3s ease",
                          "&:hover": {
                            backgroundColor: "#cbd5e1",
                            transform: "scale(1.05)",
                          },
                        }}
                      >
                        <FontAwesomeIcon icon={faUpRightAndDownLeftFromCenter} size="sm" color="#0f172a" />

                      </VuiBox>
                    </Tooltip>
                  
                    {/* Botão 2: Acessar o site (abre nova aba) */}
                    <Tooltip title="Acessar o site" placement="left">
                      <VuiBox
                        onClick={() => window.open(project.assets.externalUrl, "_blank")}
                        sx={{
                          width: "44px",
                          height: "44px",
                          borderRadius: "999px",
                          backgroundColor: "rgba(255, 255, 255, 0.5)", // Aqui adiciona a transparência
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                          boxShadow: "0 0 10px rgba(0,0,0,0.2)",
                          transition: "all 0.3s ease",
                          "&:hover": {
                            backgroundColor: "#cbd5e1",
                            transform: "scale(1.05)",
                          },
                        }}
                      >
                        <FontAwesomeIcon icon={faArrowUpRightFromSquare} size="sm" color="#0f172a" />
                      </VuiBox>
                    </Tooltip>
                  </VuiBox>
                  )}
                </VuiBox>

                {modalImagem && (
                  <Dialog
                  open={true}
                  onClose={() => setModalImagem(null)}
                  maxWidth={customMaxWidth}
                  fullWidth // ← garante que o maxWidth seja aplicado corretamente
                  PaperProps={{
                    sx: {
                      backgroundColor: "#0f172a",
                      borderRadius: "20px",
                      p: 2,
                    },
                  }}
                >
                    <DialogTitle>
                      <VuiBox display="flex" justifyContent="space-between" alignItems="center">
                        <VuiTypography variant="body1" color="white" fontWeight="medium">
                          Site formato Desktop
                        </VuiTypography>
                        <IconButton onClick={() => setModalImagem(null)} sx={{ color: "#fff" }}>
                          <CloseIcon />
                        </IconButton>
                      </VuiBox>
                    </DialogTitle>
                    <DialogContent>
                      <img
                        src={modalImagem}
                        alt="Imagem ampliada"
                        style={{
                          width: "100%",
                          maxHeight: "auto",
                          objectFit: "cover",
                          borderRadius: "12px",
                        }}
                      />
                    </DialogContent>
                  </Dialog> 
                )}            
              </>
            ) : (
              
              <>
                {/* Estrutura padrão para outros cards */}
                {project.assets?.landingPage && (
                  <img
                    src={project.assets.landingPage}
                    alt="Landing Page"
                    style={{
                      width: "100%",
                      borderRadius: "12px",
                      marginTop: "20px",
                      boxShadow: "0 0 0 1px #A3E635",
                    }}
                  />
                )}
              </>
            )}

            {project.assets?.catalogoSlides && (
              <VuiBox
                sx={{
                  width: "100%",
                  borderRadius: "20px",
                  overflow: "visible", // 🔵 Aqui agora é VISÍVEL para permitir as setas fora do box
                  mt: 4,
                  position: "relative",
                  aspectRatio: "960 / 624",
                }}
              >
                <Slider
                  dots={true}
                  infinite={true}
                  speed={500}
                  slidesToShow={1}
                  slidesToScroll={1}
                  arrows={true}
                  nextArrow={<NextArrow />}
                  prevArrow={<PrevArrow />}
                >
                  {project.assets.catalogoSlides.map((src, idx) => (
                    <VuiBox
                      key={idx}
                      sx={{
                        width: "100%",
                        height: "100%",
                        overflow: "hidden", // 🔵 Agora o conteúdo da imagem sim é que fica escondido
                        borderRadius: "20px", // 🔵 Bordas arredondadas só aqui
                        position: "relative",
                      }}
                    >
                      <img
                        src={src}
                        alt={`Página Catálogo ${idx + 1}`}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          display: "block",
                        }}
                      />
                    </VuiBox>
                  ))}
                </Slider>
              </VuiBox>
            )}

            {/* PDF para download, se existir */}
            {project.assets?.pdfPortifolio && (
              <VuiBox mt={3}>
                <a
                  href={project.assets.pdfPortifolio}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    color: "#A3E635",
                    textDecoration: "underline",
                    fontWeight: "bold",
                  }}
                >
                  Baixar Catálogo em PDF
                </a>
              </VuiBox>
            )}

            {project.stackNote && (
              <>
                <VuiBox mt={4} mb={1} sx={{ borderBottom: "1px solid #3A3B4E" }} />
                <VuiBox mt={2}>
                  <VuiTypography variant="subtitle2" color="white" fontWeight="bold" gutterBottom>
                    Stack Técnica
                  </VuiTypography>
                  <VuiTypography variant="body2" color="text" whiteSpace="pre-line">
                    {project.stackNote.trim()}
                  </VuiTypography>
                </VuiBox>
              </>
            )}

          </VuiBox>
        </DialogContent>
      </Dialog>

      {modalImagem && (
      <Dialog
        open={true}
        onClose={() => setModalImagem(null)}
        maxWidth={customMaxWidth}
        fullWidth
        PaperProps={{
          sx: {
            backgroundColor: "#0f172a",
            borderRadius: "20px",
            p: 2,
          },
        }}
      >
        <DialogTitle>
          <VuiBox display="flex" justifyContent="space-between" alignItems="center">
            <VuiTypography variant="body1" color="white" fontWeight="medium">
               {/* Retirei o texto por redundância: "Imagem ampliada" */}
            </VuiTypography>
            <IconButton onClick={() => setModalImagem(null)} sx={{ color: "#fff" }}>
              <CloseIcon />
            </IconButton>
          </VuiBox>
        </DialogTitle>
        <DialogContent>
          <img
            src={modalImagem}
            alt="Imagem ampliada"
            style={{
              width: "100%",
              maxHeight: "auto",
              objectFit: "cover",
              borderRadius: "12px",
            }}
          />
        </DialogContent>
      </Dialog>
    )}

    {modalVideo && (() => {
      const isVertical =
        modalVideo.includes("1080x1920") ||
        modalVideo.includes("reels") ||
        modalVideo.includes("vertical");

      return (
        <Dialog
          open={true}
          onClose={() => setModalVideo(null)}
          maxWidth="md"
          fullWidth
          PaperProps={{
            sx: {
              backgroundColor: "#0f172a",
              borderRadius: "20px",
              p: 2,
            },
          }}
        >
          <DialogTitle>
            <VuiBox display="flex" justifyContent="space-between" alignItems="center">
              <VuiTypography variant="body1" color="white" fontWeight="medium">
                Visualização de Vídeo
              </VuiTypography>
              <IconButton onClick={() => setModalVideo(null)} sx={{ color: "#fff" }}>
                <CloseIcon />
              </IconButton>
            </VuiBox>
          </DialogTitle>

          <DialogContent>
            {modalVideo.endsWith(".mp4") ? (
              <video
                controls
                autoPlay
                style={{
                  width: "100%",
                  height: isVertical ? "calc(100vh - 200px)" : "480px",
                  borderRadius: "12px",
                  objectFit: "contain",
                  margin: "0 auto",
                  display: "block",
                }}
              >
                <source src={modalVideo} type="video/mp4" />
                Seu navegador não suporta vídeo HTML5.
              </video>
            ) : (
              <ReactPlayer
                url={modalVideo}
                width="100%"
                height={isVertical ? "calc(100vh - 200px)" : "480px"}
                playing={true}
                controls
                style={{
                  borderRadius: "12px",
                  overflow: "hidden",
                  margin: "0 auto",
                }}
              />
            )}
          </DialogContent>
        </Dialog>
      );
    })()}


    </>
  );
};

export default PortfolioModal;

// ------------------------------------------------------------------
// COMPONENTE DE TRANSIÇÃO DE IMAGENS EXCLUSIVO PARA Landing Page LikePi
// ------------------------------------------------------------------

function SlideShowLikePi({ images }) {
  const [current, setCurrent] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    const timer = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        setCurrent((prev) => (prev + 1) % images.length);
        setFade(true);
      }, 300);
    }, 3000);
    return () => clearInterval(timer);
  }, [images.length]);

  return (
    <img
      src={images[current]}
      alt={`Slide ${current + 1}`}
      style={{
        width: "100%",
        height: "100%",
        display: "block",
        objectFit: "cover",
        borderTopRightRadius: "20px",
        borderBottomRightRadius: "0px",
        borderTopLeftRadius: "0",
        borderBottomLeftRadius: "0",
        transition: "opacity 0.8s ease-in-out",
        opacity: fade ? 1 : 0,
      }}
    />
  );
}